import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import StickyNoteCTA from '../components/StickyNoteCTA';

// Option A Compact - Fuschia Pink Theme
const OptionACompact = () => {
  const navigate = useNavigate();
  
  const handleGetStarted = () => {
    navigate('/auth');
  };

  return (
    <div style={{ background: 'var(--bg-page)' }}>
      {/* Top Navigation Bar */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 50,
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(8px)',
        borderBottom: '1px solid rgba(0,0,0,0.1)',
        padding: '12px 24px'
      }}>
        <div style={{ 
          maxWidth: '1400px', 
          margin: '0 auto', 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center' 
        }}>
          <div style={{ fontSize: '1.2rem', fontWeight: '700', color: '#2C2823' }}>
            Switch Schools
          </div>
          <button
            onClick={() => navigate('/parent-login')}
            style={{
              background: 'transparent',
              color: '#E85D35',
              border: '2px solid #E85D35',
              borderRadius: '10rem',
              padding: '8px 20px',
              fontSize: '0.9rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.background = '#E85D35';
              e.target.style.color = 'white';
            }}
            onMouseOut={(e) => {
              e.target.style.background = 'transparent';
              e.target.style.color = '#E85D35';
            }}
          >
            Parent Login
          </button>
        </div>
      </div>
      
      <StickyNoteCTA price="RM4.99" ctaText="Start at RM4.99" />
      
      {/* Compact Split Hero Section */}
      <section style={{ display: 'flex', minHeight: '90vh', flexWrap: 'wrap', marginTop: '60px' }}>
        {/* Left Side - Content */}
        <div
          style={{
            flex: '1 1 50%',
            minWidth: '320px',
            background: 'linear-gradient(135deg, #FFE5D0 0%, #FFDDB8 50%, #FFC9EA 100%)',
            display: 'flex',
            alignItems: 'center',
            padding: 'clamp(30px, 6vw, 60px) clamp(24px, 6vw, 60px)',
          }}
        >
          <div style={{ maxWidth: '600px', margin: '0 auto', width: '100%' }}>
            <h1
              style={{
                fontSize: 'clamp(1.8rem, 4vw, 3.5rem)',
                fontWeight: '900',
                lineHeight: '1.05',
                color: '#2C2823',
                marginBottom: '20px',
                fontFamily: "'PP Right Grotesk', 'Inter', Arial, sans-serif",
              }}
            >
              CONFIDENT SCHOOL DECISIONS, BUILT AROUND YOUR CHILD.
            </h1>

            <p
              style={{
                fontSize: 'clamp(1rem, 1.3vw, 1.25rem)',
                lineHeight: '1.5',
                color: '#6B6560',
                marginBottom: '28px',
              }}
            >
              Answer 15 questions. Get a school shortlist built around your child.
            </p>

            <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap', marginBottom: '32px' }} id="cta-section">
              <button
                onClick={handleGetStarted}
                style={{
                  background: '#E85D35',
                  color: 'white',
                  border: 'none',
                  borderRadius: '10rem',
                  padding: 'clamp(0.9em, 1.2em, 1.2em) clamp(1.8em, 2.5em, 2.5em)',
                  fontSize: 'clamp(0.95rem, 1.1rem, 1.1rem)',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'all 0.3s ease',
                  textTransform: 'uppercase',
                  boxShadow: '0 4px 16px rgba(232, 93, 53, 0.25)',
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'scale(1.02)';
                  e.target.style.background = '#C84B31';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'scale(1)';
                  e.target.style.background = '#E85D35';
                }}
              >
                Find the Right School
                <ArrowRight size={20} />
              </button>
            </div>

            <div style={{ display: 'flex', gap: 'clamp(20px, 4vw, 32px)', flexWrap: 'wrap' }}>
              <div>
                <div style={{ fontSize: 'clamp(1.4rem, 1.8vw, 1.8rem)', fontWeight: '900', color: '#E85D35', lineHeight: '1' }}>120</div>
                <div style={{ fontSize: 'clamp(0.65rem, 0.8rem, 0.8rem)', color: '#6B6560', textTransform: 'uppercase', letterSpacing: '0.1em', marginTop: '4px' }}>
                  International Schools Covered
                </div>
              </div>
              <div>
                <div style={{ fontSize: 'clamp(1.4rem, 1.8vw, 1.8rem)', fontWeight: '900', color: '#E85D35', lineHeight: '1' }}>6</div>
                <div style={{ fontSize: 'clamp(0.65rem, 0.8rem, 0.8rem)', color: '#6B6560', textTransform: 'uppercase', letterSpacing: '0.1em', marginTop: '4px' }}>
                  Personalized Matches in Premium Report
                </div>
              </div>
              <div>
                <div style={{ fontSize: 'clamp(1.4rem, 1.8vw, 1.8rem)', fontWeight: '900', color: '#E85D35', lineHeight: '1' }}>5+</div>
                <div style={{ fontSize: 'clamp(0.65rem, 0.8rem, 0.8rem)', color: '#6B6560', textTransform: 'uppercase', letterSpacing: '0.1em', marginTop: '4px' }}>
                  Major Curriculum Types Supported
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Image */}
        <div
          style={{
            flex: '1 1 50%',
            minWidth: '320px',
            minHeight: 'clamp(350px, 45vh, 500px)',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <img
            src="https://customer-assets.emergentagent.com/job_clean-typography-1/artifacts/9o0b6xhf_pexels-katerina-holmes-5905552.jpg"
            alt="Students in classroom raising hands"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
            }}
          />
        </div>
      </section>

      {/* Build Version Footer - Temporary for deployment verification */}
      <div style={{
        position: 'fixed',
        bottom: '10px',
        right: '10px',
        background: 'rgba(0,0,0,0.7)',
        color: 'white',
        padding: '6px 12px',
        borderRadius: '6px',
        fontSize: '11px',
        fontFamily: 'monospace',
        zIndex: 9999
      }}>
        Build: {new Date().toLocaleString('en-MY', { 
          year: 'numeric', 
          month: 'short', 
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })} | v{process.env.REACT_APP_VERSION || '1.0.0'}
      </div>
    </div>
  );
};

export default OptionACompact;
